import { Message } from 'primeng/api';

export interface NotificationConfig extends Message {
  type?: NotificationType;
}

export enum NotificationType {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}
